import * as THREE from 'three'
import * as BufferGeometryUtils from 'three/examples/jsm/utils/BufferGeometryUtils.js'

const vertexShader = `
uniform float outline;
void main() {
  gl_Position = projectionMatrix * modelViewMatrix * vec4(position + normal * outline, 1.0);
}
`

const fragmentShader = `
uniform vec3 color;
uniform float opacity;
void main() {
  gl_FragColor = vec4(color, opacity);
}
`
const outlineMaterial = new THREE.ShaderMaterial({
  uniforms: {
    color: { value: new THREE.Color('#f00') },
    opacity: { value: 1.0 },
    outline: { value: 0.2 }
  },
  vertexShader,
  fragmentShader,
  side: THREE.BackSide
})

function outlineMesh(mesh: THREE.Mesh) {
  // let outlineGeometry
  // if (mesh.geometry.isBufferGeometry) {
  // outlineGeometry = new THREE.BufferGeometry().fromBufferGeometry(mesh.geometry)
  // } else {
  let outlineGeometry = mesh.geometry.clone()
  // }
  BufferGeometryUtils.mergeGeometries([mesh.geometry, outlineGeometry]) //.mergeVertices()
  outlineGeometry.computeVertexNormals()
  const newMesh = new THREE.Mesh(outlineGeometry, outlineMaterial.clone())
  mesh.add(newMesh)
  newMesh.name = 'outline'
  return newMesh
}

// function outlineAnimate(mesh, t) {
//   mesh.rotation.x += 0.01
//   mesh.rotation.y += 0.02
//   mesh.rotation.z += 0.01
//   let color = mesh.getObjectByName('outline').material.uniforms.color.value
//   color.r = Math.sin(t * 0.01 + Math.PI) * 0.5 + 0.5
//   color.g = Math.sin(t * 0.01 + Math.PI * 0.5) * 0.5 + 0.5
//   color.b = Math.sin(t * 0.01 + Math.PI) * 0.5 + 0.5
//   renderer.render(scene, camera)
//   window.requestAnimationFrame(animate)
// }
